import * as React from 'react';

import * as styles from './styles.css';

interface INewAnswerFooterProps {
  next: React.ReactElement;
}

export const NewAnswerFooter = ({ next }: INewAnswerFooterProps) => {
  return (
    <div className={styles['container']}>
      <div className={styles['button']}>{next}</div>
    </div>
  );
};
